export const MONTOS_RECIBIDOS = "MONTOS_RECIBIDOS";
